export default __webpack_public_path__ + "static/media/SWT1570.34I-38090_-22422_0.ce614d1c.jpg";